import { Pipe, PipeTransform, inject } from '@angular/core';

import { RegistreStore } from '../state/registre.store';

@Pipe({ name: 'medic_status' })
export class MedicStatusPipe implements PipeTransform {
  private readonly registreStore = inject(RegistreStore);

  transform(value: number | string | null | undefined): string {
    const item = this.registreStore.medicStatus().filter(itemFilter => itemFilter.id === value);
    if (item.length > 0) {
        return item[0].nume;
    } else {
        return value == null ? '' : value.toString();
    }
  }

}
